export {renderBackdropTeamModal}
    
    function renderBackdropTeamModal() {
    return `<div class="backdrop__team-modal is-hidden"></div>`
}